import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { LEAD_STATUSES } from '@/lib/constants';

const LeadStatusControls = ({ assessmentId, value, onChange }) => (
  <Select value={value} onValueChange={(v) => onChange(assessmentId, v)}>
    <SelectTrigger className="w-[180px]">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {LEAD_STATUSES.map(status => (
        <SelectItem key={status} value={status}>{status}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default LeadStatusControls;
